module.exports = __webpack_public_path__ + "nu.4d01f4d6.svg";